import type { ComponentType } from '@grafikr/components';



const Component: ComponentType = (node) => {
  const phoneNumberArray = [
    {
      "dial_code": "+93",
      "code": "AF",
      "placeholder": "070 123 4567"
    },
    {
      "dial_code": "+355",
      "code": "AL",
      "placeholder": "066 123 4567"
    },
    {
      "dial_code": "+213",
      "code": "DZ",
      "placeholder": "021 23 45 67"
    },
    {
      "dial_code": "+1 684",
      "code": "AS",
      "placeholder": "(684) 733-1234"
    },
    {
      "dial_code": "+376",
      "code": "AD",
      "placeholder": "312 345"
    },
    {
      "dial_code": "+244",
      "code": "AO",
      "placeholder": "923 123 456"
    },
    {
      "dial_code": "+1 264",
      "code": "AI",
      "placeholder": "(264) 235-1234"
    },
    {
      "dial_code": "+1268",
      "code": "AG",
      "placeholder": "(268) 464-1234"
    },
    {
      "dial_code": "+54",
      "code": "AR",
      "placeholder": "11 2345-6789"
    },
    {
      "dial_code": "+374",
      "code": "AM",
      "placeholder": "077 123456"
    },
    {
      "dial_code": "+297",
      "code": "AW",
      "placeholder": "560 1234"
    },
    {
      "dial_code": "+61",
      "code": "AU",
      "placeholder": "0412 345 678"
    },
    {
      "dial_code": "+43",
      "code": "AT",
      "placeholder": "0664 123456"
    },
    {
      "dial_code": "+994",
      "code": "AZ",
      "placeholder": "040 123 45 67"
    },
    {
      "dial_code": "+1 242",
      "code": "BS",
      "placeholder": "(242) 359-1234"
    },
    {
      "dial_code": "+973",
      "code": "BH",
      "placeholder": "3600 1234"
    },
    {
      "dial_code": "+880",
      "code": "BD",
      "placeholder": "018 12345 678"
    },
    {
      "dial_code": "+1 246",
      "code": "BB",
      "placeholder": "(246) 250-1234"
    },
    {
      "dial_code": "+375",
      "code": "BY",
      "placeholder": "8 029 123 45 67"
    },
    {
      "dial_code": "+32",
      "code": "BE",
      "placeholder": "0470 12 34 56"
    },
    {
      "dial_code": "+501",
      "code": "BZ",
      "placeholder": "622-1234"
    },
    {
      "dial_code": "+229",
      "code": "BJ",
      "placeholder": "90 01 23 45"
    },
    {
      "dial_code": "+1 441",
      "code": "BM",
      "placeholder": "(441) 370-1234"
    },
    {
      "dial_code": "+975",
      "code": "BT",
      "placeholder": "17 12 34 56"
    },
    {
      "dial_code": "+387",
      "code": "BA",
      "placeholder": "061 123 456"
    },
    {
      "dial_code": "+267",
      "code": "BW",
      "placeholder": "71 123 456"
    },
    {
      "dial_code": "+55",
      "code": "BR",
      "placeholder": "11 91234-5678"
    },
    {
      "dial_code": "+246",
      "code": "IO",
      "placeholder": "246 123 456"
    },
    {
      "dial_code": "+359",
      "code": "BG",
      "placeholder": "087 123 4567"
    },
    {
      "dial_code": "+226",
      "code": "BF",
      "placeholder": "70 12 34 56"
    },
    {
      "dial_code": "+257",
      "code": "BI",
      "placeholder": "79 56 12 34"
    },
    {
      "dial_code": "+855",
      "code": "KH",
      "placeholder": "012 345 678"
    },
    {
      "dial_code": "+237",
      "code": "CM",
      "placeholder": "6 71 23 45 67"
    },
    {
      "dial_code": "+1",
      "code": "CA",
      "placeholder": "(204) 123-4567"
    },
    {
      "dial_code": "+238",
      "code": "CV",
      "placeholder": "991 12 34"
    },
    {
      "dial_code": "+ 345",
      "code": "KY",
      "placeholder": "(345) 323-1234"
    },
    {
      "dial_code": "+236",
      "code": "CF",
      "placeholder": "70 01 23 45"
    },
    {
      "dial_code": "+235",
      "code": "TD",
      "placeholder": "63 01 23 45"
    },
    {
      "dial_code": "+56",
      "code": "CL",
      "placeholder": "9 6123 4567"
    },
    {
      "dial_code": "+86",
      "code": "CN",
      "placeholder": "131 2345 6789"
    },
    {
      "dial_code": "+61",
      "code": "CX",
      "placeholder": "0412 345 678"
    },
    {
      "dial_code": "+57",
      "code": "CO",
      "placeholder": "321 1234567"
    },
    {
      "dial_code": "+269",
      "code": "KM",
      "placeholder": "321 23 45"
    },
    {
      "dial_code": "+242",
      "code": "CG",
      "placeholder": "06 123 4567"
    },
    {
      "dial_code": "+682",
      "code": "CK",
      "placeholder": "71 234"
    },
    {
      "dial_code": "+506",
      "code": "CR",
      "placeholder": "8312 3456"
    },
    {
      "dial_code": "+385",
      "code": "HR",
      "placeholder": "091 234 5678"
    },
    {
      "dial_code": "+53",
      "code": "CU",
      "placeholder": "05 1234567"
    },
    {
      "dial_code": "+537",
      "code": "CY",
      "placeholder": "96 123456"
    },
    {
      "dial_code": "+420",
      "code": "CZ",
      "placeholder": "601 123 456"
    },
    {
      "dial_code": "+45",
      "code": "DK",
      "placeholder": "20 12 34 56"
    },
    {
      "dial_code": "+253",
      "code": "DJ",
      "placeholder": "77 83 10 01"
    },
    {
      "dial_code": "+1 767",
      "code": "DM",
      "placeholder": "(767) 225-1234"
    },
    {
      "dial_code": "+1 849",
      "code": "DO",
      "placeholder": "(849) 234-5678"
    },
    {
      "dial_code": "+593",
      "code": "EC",
      "placeholder": "099 123 4567"
    },
    {
      "dial_code": "+20",
      "code": "EG",
      "placeholder": "0100 123 4567"
    },
    {
      "dial_code": "+503",
      "code": "SV",
      "placeholder": "7012 3456"
    },
    {
      "dial_code": "+240",
      "code": "GQ",
      "placeholder": "222 123 456"
    },
    {
      "dial_code": "+291",
      "code": "ER",
      "placeholder": "07 123 456"
    },
    {
      "dial_code": "+372",
      "code": "EE",
      "placeholder": "5123 4567"
    },
    {
      "dial_code": "+251",
      "code": "ET",
      "placeholder": "091 123 4567"
    },
    {
      "dial_code": "+298",
      "code": "FO",
      "placeholder": "211234"
    },
    {
      "dial_code": "+679",
      "code": "FJ",
      "placeholder": "701 2345"
    },
    {
      "dial_code": "+358",
      "code": "FI",
      "placeholder": "041 2345678"
    },
    {
      "dial_code": "+33",
      "code": "FR",
      "placeholder": "06 12 34 56 78"
    },
    {
      "dial_code": "+594",
      "code": "GF",
      "placeholder": "0694 20 12 34"
    },
    {
      "dial_code": "+689",
      "code": "PF",
      "placeholder": "87 12 34 56"
    },
    {
      "dial_code": "+241",
      "code": "GA",
      "placeholder": "06 03 12 34"
    },
    {
      "dial_code": "+220",
      "code": "GM",
      "placeholder": "301 2345"
    },
    {
      "dial_code": "+995",
      "code": "GE",
      "placeholder": "555 12 34 56"
    },
    {
      "dial_code": "+49",
      "code": "DE",
      "placeholder": "01512 3456789"
    },
    {
      "dial_code": "+233",
      "code": "GH",
      "placeholder": "023 123 4567"
    },
    {
      "dial_code": "+350",
      "code": "GI",
      "placeholder": "57123456"
    },
    {
      "dial_code": "+30",
      "code": "GR",
      "placeholder": "691 234 5678"
    },
    {
      "dial_code": "+299",
      "code": "GL",
      "placeholder": "22 12 34"
    },
    {
      "dial_code": "+1 473",
      "code": "GD",
      "placeholder": "(473) 403-1234"
    },
    {
      "dial_code": "+590",
      "code": "GP",
      "placeholder": "0690 30 12 34"
    },
    {
      "dial_code": "+1 671",
      "code": "GU",
      "placeholder": "(671) 300-1234"
    },
    {
      "dial_code": "+502",
      "code": "GT",
      "placeholder": "5123 4567"
    },
    {
      "dial_code": "+224",
      "code": "GN",
      "placeholder": "601 12 34 56"
    },
    {
      "dial_code": "+245",
      "code": "GW",
      "placeholder": "955 012 345"
    },
    {
      "dial_code": "+595",
      "code": "GY",
      "placeholder": "609 1234"
    },
    {
      "dial_code": "+509",
      "code": "HT",
      "placeholder": "34 10 1234"
    },
    {
      "dial_code": "+504",
      "code": "HN",
      "placeholder": "9123-4567"
    },
    {
      "dial_code": "+36",
      "code": "HU",
      "placeholder": "20 123 4567"
    },
    {
      "dial_code": "+354",
      "code": "IS",
      "placeholder": "611 1234"
    },
    {
      "dial_code": "+91",
      "code": "IN",
      "placeholder": "098765 43210"
    },
    {
      "dial_code": "+62",
      "code": "ID",
      "placeholder": "0812-345-678"
    },
    {
      "dial_code": "+964",
      "code": "IQ",
      "placeholder": "0790 123 4567"
    },
    {
      "dial_code": "+353",
      "code": "IE",
      "placeholder": "085 123 4567"
    },
    {
      "dial_code": "+972",
      "code": "IL",
      "placeholder": "050-123-4567"
    },
    {
      "dial_code": "+39",
      "code": "IT",
      "placeholder": "312 345 6789"
    },
    {
      "dial_code": "+1 876",
      "code": "JM",
      "placeholder": "(876) 210-1234"
    },
    {
      "dial_code": "+81",
      "code": "JP",
      "placeholder": "090-1234-5678"
    },
    {
      "dial_code": "+962",
      "code": "JO",
      "placeholder": "07 9012 3456"
    },
    {
      "dial_code": "+7 7",
      "code": "KZ",
      "placeholder": "8 701 123 4567"
    },
    {
      "dial_code": "+254",
      "code": "KE",
      "placeholder": "0712 345678"
    },
    {
      "dial_code": "+686",
      "code": "KI",
      "placeholder": "72012345"
    },
    {
      "dial_code": "+965",
      "code": "KW",
      "placeholder": "500 12345"
    },
    {
      "dial_code": "+996",
      "code": "KG",
      "placeholder": "0700 123 456"
    },
    {
      "dial_code": "+371",
      "code": "LV",
      "placeholder": "21 234 567"
    },
    {
      "dial_code": "+961",
      "code": "LB",
      "placeholder": "71 123 456"
    },
    {
      "dial_code": "+266",
      "code": "LS",
      "placeholder": "5012 3456"
    },
    {
      "dial_code": "+231",
      "code": "LR",
      "placeholder": "077 012 3456"
    },
    {
      "dial_code": "+423",
      "code": "LI",
      "placeholder": "660 123 456"
    },
    {
      "dial_code": "+370",
      "code": "LT",
      "placeholder": "612 34567"
    },
    {
      "dial_code": "+352",
      "code": "LU",
      "placeholder": "621 123 456"
    },
    {
      "dial_code": "+261",
      "code": "MG",
      "placeholder": "032 12 345 67"
    },
    {
      "dial_code": "+265",
      "code": "MW",
      "placeholder": "0991 23 45 67"
    },
    {
      "dial_code": "+60",
      "code": "MY",
      "placeholder": "012-345 6789"
    },
    {
      "dial_code": "+960",
      "code": "MV",
      "placeholder": "771-2345"
    },
    {
      "dial_code": "+223",
      "code": "ML",
      "placeholder": "65 01 23 45"
    },
    {
      "dial_code": "+356",
      "code": "MT",
      "placeholder": "7712 3456"
    },
    {
      "dial_code": "+692",
      "code": "MH",
      "placeholder": "235-1234"
    },
    {
      "dial_code": "+596",
      "code": "MQ",
      "placeholder": "0696 20 12 34"
    },
    {
      "dial_code": "+222",
      "code": "MR",
      "placeholder": "22 12 34 56"
    },
    {
      "dial_code": "+230",
      "code": "MU",
      "placeholder": "5251 2345"
    },
    {
      "dial_code": "+262",
      "code": "YT",
      "placeholder": "0639 12 34 56"
    },
    {
      "dial_code": "+52",
      "code": "MX",
      "placeholder": "55 1234 5678"
    },
    {
      "dial_code": "+377",
      "code": "MC",
      "placeholder": "06 12 34 56 78"
    },
    {
      "dial_code": "+976",
      "code": "MN",
      "placeholder": "8812 3456"
    },
    {
      "dial_code": "+382",
      "code": "ME",
      "placeholder": "067 123 456"
    },
    {
      "dial_code": "+1664",
      "code": "MS",
      "placeholder": "(664) 492-1234"
    },
    {
      "dial_code": "+212",
      "code": "MA",
      "placeholder": "0650-123456"
    },
    {
      "dial_code": "+95",
      "code": "MM",
      "placeholder": "09 123 4567"
    },
    {
      "dial_code": "+264",
      "code": "NA",
      "placeholder": "081 123 4567"
    },
    {
      "dial_code": "+674",
      "code": "NR",
      "placeholder": "555 1234"
    },
    {
      "dial_code": "+977",
      "code": "NP",
      "placeholder": "984-1234567"
    },
    {
      "dial_code": "+31",
      "code": "NL",
      "placeholder": "06 12345678"
    },
    {
      "dial_code": "+599",
      "code": "AN",
      "placeholder": ""
    },
    {
      "dial_code": "+687",
      "code": "NC",
      "placeholder": "75 12 34"
    },
    {
      "dial_code": "+64",
      "code": "NZ",
      "placeholder": "021 123 4567"
    },
    {
      "dial_code": "+505",
      "code": "NI",
      "placeholder": "8123 4567"
    },
    {
      "dial_code": "+227",
      "code": "NE",
      "placeholder": "93 12 34 56"
    },
    {
      "dial_code": "+234",
      "code": "NG",
      "placeholder": "0802 123 4567"
    },
    {
      "dial_code": "+683",
      "code": "NU",
      "placeholder": "1234"
    },
    {
      "dial_code": "+672",
      "code": "NF",
      "placeholder": "3 81234"
    },
    {
      "dial_code": "+1 670",
      "code": "MP",
      "placeholder": "(670) 234-5678"
    },
    {
      "dial_code": "+47",
      "code": "NO",
      "placeholder": "406 12 345"
    },
    {
      "dial_code": "+968",
      "code": "OM",
      "placeholder": "9212 3456"
    },
    {
      "dial_code": "+92",
      "code": "PK",
      "placeholder": "0301 2345678"
    },
    {
      "dial_code": "+680",
      "code": "PW",
      "placeholder": "620 1234"
    },
    {
      "dial_code": "+507",
      "code": "PA",
      "placeholder": "6001-2345"
    },
    {
      "dial_code": "+675",
      "code": "PG",
      "placeholder": "7012 3456"
    },
    {
      "dial_code": "+595",
      "code": "PY",
      "placeholder": "0961 456789"
    },
    {
      "dial_code": "+51",
      "code": "PE",
      "placeholder": "912 345 678"
    },
    {
      "dial_code": "+63",
      "code": "PH",
      "placeholder": "0912 345 6789"
    },
    {
      "dial_code": "+48",
      "code": "PL",
      "placeholder": "512 345 678"
    },
    {
      "dial_code": "+351",
      "code": "PT",
      "placeholder": "912 345 678"
    },
    {
      "dial_code": "+1 939",
      "code": "PR",
      "placeholder": "(939) 123-4567"
    },
    {
      "dial_code": "+974",
      "code": "QA",
      "placeholder": "3312 3456"
    },
    {
      "dial_code": "+40",
      "code": "RO",
      "placeholder": "0712 345 678"
    },
    {
      "dial_code": "+250",
      "code": "RW",
      "placeholder": "0788 123 456"
    },
    {
      "dial_code": "+685",
      "code": "WS",
      "placeholder": "72 12345"
    },
    {
      "dial_code": "+378",
      "code": "SM",
      "placeholder": "0549 123456"
    },
    {
      "dial_code": "+966",
      "code": "SA",
      "placeholder": "051 234 5678"
    },
    {
      "dial_code": "+221",
      "code": "SN",
      "placeholder": "70 123 45 67"
    },
    {
      "dial_code": "+381",
      "code": "RS",
      "placeholder": "060 1234567"
    },
    {
      "dial_code": "+248",
      "code": "SC",
      "placeholder": "2 510 123"
    },
    {
      "dial_code": "+232",
      "code": "SL",
      "placeholder": "025 123456"
    },
    {
      "dial_code": "+65",
      "code": "SG",
      "placeholder": "8123 4567"
    },
    {
      "dial_code": "+421",
      "code": "SK",
      "placeholder": "0912 345 678"
    },
    {
      "dial_code": "+386",
      "code": "SI",
      "placeholder": "031 234 567"
    },
    {
      "dial_code": "+677",
      "code": "SB",
      "placeholder": "74 12345"
    },
    {
      "dial_code": "+27",
      "code": "ZA",
      "placeholder": "071 123 4567"
    },
    {
      "dial_code": "+500",
      "code": "GS",
      "placeholder": ""
    },
    {
      "dial_code": "+34",
      "code": "ES",
      "placeholder": "612 34 56 78"
    },
    {
      "dial_code": "+94",
      "code": "LK",
      "placeholder": "071 234 5678"
    },
    {
      "dial_code": "+249",
      "code": "SD",
      "placeholder": "091 123 4567"
    },
    {
      "dial_code": "+597",
      "code": "SR",
      "placeholder": "741-2345"
    },
    {
      "dial_code": "+268",
      "code": "SZ",
      "placeholder": "7612 3456"
    },
    {
      "dial_code": "+46",
      "code": "SE",
      "placeholder": "070 123 45 67"
    },
    {
      "dial_code": "+41",
      "code": "CH",
      "placeholder": "079 123 45 67"
    },
    {
      "dial_code": "+992",
      "code": "TJ",
      "placeholder": "917 12 3456"
    },
    {
      "dial_code": "+66",
      "code": "TH",
      "placeholder": "081 234 5678"
    },
    {
      "dial_code": "+228",
      "code": "TG",
      "placeholder": "90 11 23 45"
    },
    {
      "dial_code": "+690",
      "code": "TK",
      "placeholder": "1234"
    },
    {
      "dial_code": "+676",
      "code": "TO",
      "placeholder": "771 5123"
    },
    {
      "dial_code": "+1 868",
      "code": "TT",
      "placeholder": "(868) 291-1234"
    },
    {
      "dial_code": "+216",
      "code": "TN",
      "placeholder": "20 123 456"
    },
    {
      "dial_code": "+90",
      "code": "TR",
      "placeholder": "0501 234 56 78"
    },
    {
      "dial_code": "+993",
      "code": "TM",
      "placeholder": "8 66 123456"
    },
    {
      "dial_code": "+1 649",
      "code": "TC",
      "placeholder": "(649) 231-1234"
    },
    {
      "dial_code": "+688",
      "code": "TV",
      "placeholder": "901234"
    },
    {
      "dial_code": "+256",
      "code": "UG",
      "placeholder": "0712 345678"
    },
    {
      "dial_code": "+380",
      "code": "UA",
      "placeholder": "039 123 4567"
    },
    {
      "dial_code": "+971",
      "code": "AE",
      "placeholder": "050 123 4567"
    },
    {
      "dial_code": "+44",
      "code": "GB",
      "placeholder": "07400 123456"
    },
    {
      "dial_code": "+1",
      "code": "US",
      "placeholder": "(201) 555-0123"
    },
    {
      "dial_code": "+598",
      "code": "UY",
      "placeholder": "094 231 234"
    },
    {
      "dial_code": "+998",
      "code": "UZ",
      "placeholder": "8 91 234 56 78"
    },
    {
      "dial_code": "+678",
      "code": "VU",
      "placeholder": "591 2345"
    },
    {
      "dial_code": "+681",
      "code": "WF",
      "placeholder": "50 12 34"
    },
    {
      "dial_code": "+967",
      "code": "YE",
      "placeholder": "0712 345 678"
    },
    {
      "dial_code": "+260",
      "code": "ZM",
      "placeholder": "095 5123456"
    },
    {
      "dial_code": "+263",
      "code": "ZW",
      "placeholder": "071 234 5678"
    },
    {
      "dial_code": "",
      "code": "AX",
      "placeholder": ""
    },
    {
      "dial_code": "+591",
      "code": "BO",
      "placeholder": "71234567"
    },
    {
      "dial_code": "+673",
      "code": "BN",
      "placeholder": "712 3456"
    },
    {
      "dial_code": "+61",
      "code": "CC",
      "placeholder": "0412 345 678"
    },
    {
      "dial_code": "+243",
      "code": "CD",
      "placeholder": "0991 234 567"
    },
    {
      "dial_code": "+225",
      "code": "CI",
      "placeholder": "01 23 45 67"
    },
    {
      "dial_code": "+500",
      "code": "FK",
      "placeholder": "51234"
    },
    {
      "dial_code": "+44",
      "code": "GG",
      "placeholder": "07781 123456"
    },
    {
      "dial_code": "+379",
      "code": "VA",
      "placeholder": "312 345 6789"
    },
    {
      "dial_code": "+852",
      "code": "HK",
      "placeholder": "5123 4567"
    },
    {
      "dial_code": "+98",
      "code": "IR",
      "placeholder": "0912 345 6789"
    },
    {
      "dial_code": "+44",
      "code": "IM",
      "placeholder": "07924 123456"
    },
    {
      "dial_code": "+44",
      "code": "JE",
      "placeholder": "07797 123456"
    },
    {
      "dial_code": "+850",
      "code": "KP",
      "placeholder": "0192 123 4567"
    },
    {
      "dial_code": "+82",
      "code": "KR",
      "placeholder": "010-1234-5678"
    },
    {
      "dial_code": "+856",
      "code": "LA",
      "placeholder": "020 23 123 456"
    },
    {
      "dial_code": "+218",
      "code": "LY",
      "placeholder": "091-2345678"
    },
    {
      "dial_code": "+853",
      "code": "MO",
      "placeholder": "6612 3456"
    },
    {
      "dial_code": "+389",
      "code": "MK",
      "placeholder": "070 123 456"
    },
    {
      "dial_code": "+691",
      "code": "FM",
      "placeholder": "350 1234"
    },
    {
      "dial_code": "+373",
      "code": "MD",
      "placeholder": "0621 12 345"
    },
    {
      "dial_code": "+258",
      "code": "MZ",
      "placeholder": "82 123 4567"
    },
    {
      "dial_code": "+970",
      "code": "PS",
      "placeholder": "0599 123 456"
    },
    {
      "dial_code": "+872",
      "code": "PN",
      "placeholder": "64 123"
    },
    {
      "dial_code": "+262",
      "code": "RE",
      "placeholder": "0692 12 34 56"
    },
    {
      "dial_code": "+7",
      "code": "RU",
      "placeholder": "8 912 345-67-89"
    },
    {
      "dial_code": "+590",
      "code": "BL",
      "placeholder": "0690 12 34 56"
    },
    {
      "dial_code": "+290",
      "code": "SH",
      "placeholder": "51234"
    },
    {
      "dial_code": "+1 869",
      "code": "KN",
      "placeholder": "(869) 765-2917"
    },
    {
      "dial_code": "+1 758",
      "code": "LC",
      "placeholder": "(758) 284-5678"
    },
    {
      "dial_code": "+590",
      "code": "MF",
      "placeholder": "0690 12 34 56"
    },
    {
      "dial_code": "+508",
      "code": "PM",
      "placeholder": "41 12 34"
    },
    {
      "dial_code": "+1 784",
      "code": "VC",
      "placeholder": "(784) 430-1234"
    },
    {
      "dial_code": "+239",
      "code": "ST",
      "placeholder": "981 2345"
    },
    {
      "dial_code": "+252",
      "code": "SO",
      "placeholder": "7 123456"
    },
    {
      "dial_code": "+47",
      "code": "SJ",
      "placeholder": "412 34 567"
    },
    {
      "dial_code": "+963",
      "code": "SY",
      "placeholder": "0944 567 890"
    },
    {
      "dial_code": "+886",
      "code": "TW",
      "placeholder": "0912 345 678"
    },
    {
      "dial_code": "+255",
      "code": "TZ",
      "placeholder": "0621 234 567"
    },
    {
      "dial_code": "+670",
      "code": "TL",
      "placeholder": "7721 2345"
    },
    {
      "dial_code": "+58",
      "code": "VE",
      "placeholder": "0412-1234567"
    },
    {
      "dial_code": "+84",
      "code": "VN",
      "placeholder": "091 234 56 78"
    },
    {
      "dial_code": "+1 284",
      "code": "VG",
      "placeholder": "(284) 300-1234"
    },
    {
      "dial_code": "+1 340",
      "code": "VI",
      "placeholder": "(340) 642-1234"
    }
  ]

  const tagsInput = node.querySelector<HTMLElement>('[name="customer[tags]"]');
  const tagInputList = node.querySelectorAll<HTMLElement>('[name^="tag"]');

  const countrySelect = node.querySelector<HTMLSelectElement>('[name="tag[country]"]');
  const phoneInput = node.querySelector<HTMLInputElement>('[name="customer[phone]"]');


  phoneNumberArray.forEach(phoneNumberObject => {
    let lang = navigator.language || navigator.userLanguage;
    const regionNamesByBrowser = new Intl.DisplayNames([lang, 'en'], { type: 'region' });
    const option = document.createElement('option');
    option.value = phoneNumberObject.code;
    option.text = `${regionNamesByBrowser.of(phoneNumberObject.code)} ${phoneNumberObject.dial_code}`;
    option.setAttribute('data-placeholder', phoneNumberObject.placeholder);
    if (phoneNumberObject.code === 'DK') {
      option.selected = true;
    }
    countrySelect.appendChild(option);

  });


  countrySelect.addEventListener('change', () => {
    const selectedOption = countrySelect.options[countrySelect.selectedIndex];
    const placeholder = selectedOption.getAttribute('data-placeholder');
    const prefix = selectedOption.text.split(' ')[1];
    phoneInput.setAttribute('placeholder', placeholder);
    phoneInput.setAttribute('data-prefix', prefix);
  });


  if (!tagsInput || !tagInputList) {
    return;
  }

  const updateTagsInput = () => {
    const tags = Array.from(tagInputList)
      .filter((tagInput: HTMLInputElement) => tagInput.value !== '')
      .map((tagInput: HTMLInputElement) => {
        const prefix = tagInput.getAttribute('data-prefix');
        return `${prefix}:${tagInput.value}`;
      })
      .join(',');

    tagsInput.setAttribute('value', tags);
  };

  tagInputList.forEach(tagInput => {
    tagInput.addEventListener('change', () => {
      updateTagsInput();
    });
  });
};

export default Component;
